export const AMC_TERMS_REQUIRED_REASON = 'amc_terms_required';

export const AMC_TERMS_REQUIRED_MESSAGE =
  'Go to Amazon Ads, open the Audiences section, and accept the terms and conditions. After you accept them, sync again and you can use the audience feature.';
